export const categoriesColLayout = (isArchived: boolean) =>
  isArchived ? '356px 77px 276px 212px' : '356px 77px 172px 144px 104px'
export const ThreadsColLayout = '356px 40px 148px 156px 212px'
